import React from "react";
import SEO from "../Component/SEO";
import "./service.css";
import MobileSolutions from "./MobileSolutions";
import Testing from "./Testing";
import Esolution from "./Esolution";
import BussinessIntelligence from "./BussinessIntelligence";
import DataScience from "./DataScience";
import FocusPage from "./FocusPage";
import DataEntry from "./DataEntry";
import Gfooter from "../Component/Gfooter";

function Service() {
  return (
    <div>

      <SEO
        title="Architectural & Building Solutions Services in India | NLF"
        description="NLF Solutions offers architectural and building solution services including metal ceilings, facades, roofing, furniture and acoustic solutions across India."
        canonical="https://nlfs.in/services"
        keywords="Architectural Interior Solutions, Architectural solutions, Interior solutions, Design solutions, Turnkey interior solutions, Facade solutions, Workplace solutions, architectural interior solutions in India, complete architectural solutions, commercial interior solutions"
      />
      <h1 className="seo-h1">Complete Architectural & Interior Solutions</h1>

      <FocusPage />
      {/* <MobileSolutions/> */}
      {/* <Testing/> */}
      {/* <Esolution/> */}
      {/* <BussinessIntelligence/>   */}
      {/* <DataScience/> */}
      {/* <DataEntry/> */}
      <Gfooter />
    </div>
  );
}

export default Service;
